//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import imgSrc from '../assets/javascripts/imgSrc'
import canvas from '../assets/javascripts/canvas'
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
  methods: {
    moreOrLess (event){
      $(event.target).toggleClass('up-arrow');
      $(event.target).parent().find('.risk-des').toggleClass('line')
    },
    ...mapState ({
      initData: function(state) {
        let _this = this;
        let riskData = state.vux.reportData.conclusion.risks;
        let sortedData = [];
        let normalArr = [];
        let mildArr = [];
        let severeArr = [];
        // 去除症状重复,等级取最高
        for(let i = 0; i < riskData.length; i++) {
          if(sortedData.indexOf(this.symptoms[riskData[i].position][riskData[i].code - 1]) !== -1) {
            let originLevel =  this.symptoms[riskData[i].position][riskData[i].code - 1].level;
            let nowLevel = riskData[i].level;
            let originIndex;
            let nowIndex;
            for(let i = 0; i < this.level.length; i++) {
              if(_this.level[i] == originLevel) {
                originIndex = i;
              }
              if(_this.level[i] == nowIndex) {
                nowIndex = i;
              }
            }

            if(nowIndex > originIndex) {
              this.symptoms[riskData[i].position][riskData[i].code - 1].level = nowLevel;
            } else {
              continue;
            }
          } else {
            let symptom = this.symptoms[riskData[i].position][riskData[i].code - 1];
            symptom.level = riskData[i].level;
            sortedData.push(symptom);
          }
        }

        // 按高风险到低风险排序
        for(let i = 0; i < sortedData.length; i++) {
          switch (sortedData[i].level) {
            case _this.level[3]:
              severeArr.push(sortedData[i]);
              break;
            case _this.level[2]:
              mildArr.push(sortedData[i]);
              break;
            default:
              normalArr.push(sortedData[i]);
              break;
          }
        }

        sortedData = severeArr.concat(mildArr, normalArr);
        this.sortedData = sortedData;
      }
    })
  },
  created () {
    this.initData()
  },
  data: function () {
    return {
      symptoms: {
        head: [
            {
              name: '头部侧倾',
              img: imgSrc.HEAD_SIDESWAY,
              definition: '头部过度向前伸的现象。',
              harm: {
                bone: '颈椎侧屈',
                muscle: '屈曲侧：胸锁乳突肌缩短紧张、斜角肌缩短紧张、头夹肌缩短紧张、肩胛提肌缩短紧张、颈夹肌紧张。拉长侧：胸锁乳突肌拉长、斜角肌拉长、颈夹肌拉长、肩胛提肌拉长'
              }
            },
            {
              name: '头部前倾',
              img: imgSrc.HEAD_LEAN,
              definition: '头部过度向前伸的现象。',
              harm: {
                bone: '椎弓变直或出现反弓',
                muscle: '胸锁乳突缩短紧张、斜方肌上束过度拉长、夹肌（头夹肌、颈夹肌）过度拉长、肩胛提肌紧张、斜角肌缩短紧张'
              }
            }
          ],
        shoulder: [
          {
            name: '高低肩',
            img: imgSrc.HIGH_LOW_SHOULDER,
            definition: '肩峰左右高度差超过2CM则为高低肩。',
            harm: {
              bone: '脊柱侧弯、骨盆侧倾、长短腿、高侧肩胛骨上抬、单侧足弓塌陷',
              muscle: '高侧：肩胛提肌缩短紧张、斜方肌上束缩短紧张、菱形肌紧张、斜角肌缩短紧张、胸小肌拉长、锁骨下肌紧张、前锯肌拉长紧张。低侧：'
            }
          },
          {
            name: '圆肩',
            img: imgSrc.ROUND_SHOULDER,
            definition: '由于胸小肌被动缩短，肩胛骨前引，使肩部向前和向下，造成圆肩的现象。',
            harm: {
              bone: '肩胛骨外展、胸廓变小',
              muscle: '胸大肌、胸小肌缩短紧张、菱形肌过度拉长、斜方肌拉长'
            }
          }
        ],
        trunk: [
          {
            name: '脊柱侧弯',
            img: imgSrc.SPINE_SIDESWAY,
            definition: '是指脊柱的一个或数个节段向侧方弯曲伴有椎体旋转的三维脊柱畸形的现象。',
            harm: {
              bone: '脊柱出现S型弯曲或C型弯曲',
              muscle: '凹侧肌肉缩短无力、凸侧肌肉拉长无力松弛'
            }
          }
        ],
        pelvis: [
          {
            name: '骨盆侧倾',
            img: imgSrc.PELVIS_LEAN,
            definition: '在X光片上显示的两侧髂嵴的上缘连线不在同一条水平线上，触诊时两手卡在髂嵴上缘出现一手高一手低的现象。',
            harm: {
              bone: '骨盆倾斜',
              muscle: '高侧：腰方肌缩短紧张、高髂腰缩短肌紧张、臀中肌缩短紧张，臀大肌紧张。低侧：臀大肌薄弱、腰方肌拉长无力、髂腰肌拉长无力'
            }
          }
        ],
        "lower extremity": [
          {
            name: 'O型腿',
            img: imgSrc.LEG_O,
            definition: '是指两下肢自然伸直或站立时，两足内踝能相碰而两膝不能靠拢。',
            harm: {
              bone: 'O型腿（膝内翻）',
              muscle: '髋外旋肌紧张、髋内旋肌无力、臀大肌薄弱、股骨前倾角过大'
            }
          },
          {
            name: 'X型腿',
            img: imgSrc.LEG_X,
            definition: '指两足并立时，两侧膝关节碰在一起，而两足内踝无法靠拢。',
            harm: {
              bone: 'X型腿（膝外翻）',
              muscle: '髋外展肌无力、股四头肌内侧头、髋内旋肌紧张、股二头肌紧张、髂胫束紧张'
            }
          },
          {
            name: '膝过伸',
            img: imgSrc.KNEE_OVERSTRETCH,
            definition: '在行走或站立过程中，下肢在支撑期出现膝关节过度伸展（膝伸展角度大于5°），身体重心后移，髋关节过度屈曲，身体出现后倾趋势的现象。',
            harm: {
              bone: '踝关节背屈不足，使膝关节无法向前移动',
              muscle: '臀大肌薄弱、较多情况下股四头较肌薄弱，腘绳肌过度活跃，踝关节周围韧带紧张、膝关节周围韧带及关节囊松弛'
            }
          }
        ],
      },
      sortedData: [],
      levelDes: {
        normal: {
          text: '低风险',
          color: '#79d023'
        },
        mild: {
          text: '中风险',
          color: '#ff8739'
        },
        severe: {
          text: '高风险',
          color: '#cf2f30'
        }
      },
      level: [null, 'normal', 'mild', 'severe']
    }
  },
  watch: {
    sortedData: function () {
      $.each($('.risk-canvas'), function (index, element) {
        canvas.initRiskBar({
          element: element,
          level: $(element).data('level')
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/RiskDetail.vue